import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { customerActions } from "stores/customer/customerActions";
import { masterApis } from "stores/master/masterApis";
import { localStore } from "stores/localStorage";

export const performAppLogout = async (logoutAction, history) => {
  await masterApis.updateLastActiveProduct();
  logoutAction();
  localStore.removeTakeTureToken();
  localStore.removeSSOCustomer();
  localStore.removeSsoClientId();
  setTimeout(() => {
    history.replace("/login");
  }, 1000);
};

export const useAppLogout = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return useCallback(
    () =>
      performAppLogout(
        () => dispatch(customerActions.logout()),
        history,
      ),
    [dispatch, history],
  );
};
